import { normalizeFollowUpChannel, type FollowUpChannel } from './channel'

export type { FollowUpChannel } from './channel'

export type FollowUpPayload = {
  prospect_id: string
  assigned_to: string
  scheduled_at: string
  channel: FollowUpChannel
  reason: string | null
  priority: 'medium'
  status: 'pending'
}

export type BuildFollowUpPayloadInput = {
  prospectId: string
  assignedTo: string
  scheduledAt: string
  channel: string
  reason?: string | null
}

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function buildFollowUpPayload({
  prospectId,
  assignedTo,
  scheduledAt,
  channel,
  reason,
}: BuildFollowUpPayloadInput): FollowUpPayload {
  if (!isUuid(prospectId)) {
    throw new Error(
      'El prospecto seleccionado no tiene un identificador válido.',
    )
  }

  if (!isUuid(assignedTo)) {
    throw new Error('El perfil activo no tiene un identificador válido.')
  }

  const resolvedChannel = normalizeFollowUpChannel(channel)
  if (!resolvedChannel) {
    throw new Error(
      'Elegí un canal válido: WhatsApp, Instagram, Facebook, Correo o Teléfono.',
    )
  }

  return {
    prospect_id: prospectId,
    assigned_to: assignedTo,
    scheduled_at: normalizeIsoUtc(scheduledAt),
    channel: resolvedChannel,
    reason: normalizeOptionalText(reason),
    priority: 'medium',
    status: 'pending',
  }
}

export function isUuid(value: string): boolean {
  return UUID_PATTERN.test(value)
}

function normalizeIsoUtc(value: string): string {
  const parsedDate = new Date(value)

  if (!value || Number.isNaN(parsedDate.getTime())) {
    throw new Error('La fecha programada no es válida.')
  }

  return parsedDate.toISOString()
}

function normalizeOptionalText(
  value: string | null | undefined,
): string | null {
  const normalizedValue = value?.trim()
  return normalizedValue ? normalizedValue : null
}
